import './userpage.css';

import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser as faUserRegular } from '@fortawesome/free-regular-svg-icons';
import { faMedal, faCrown } from '@fortawesome/free-solid-svg-icons';


import { Link } from 'react-router-dom';
import CoursesProgress from './CoursesProgress';
import StreakPopup from './StreakPopup';
import StreakDays from './StreakDays';
import balance from '../imagesHome/balance.png';
import certificate from './../header/images/certificate.png';
import coin from '../imagesHome/coins.png';
import light from '../imagesHome/light.png'
import backgrounduserpage from '../imagesHome/background-user-page.png'
import crown from '../imagesHome/crown.png'




const apiUrl = process.env.REACT_APP_API_URL;

const UserPage = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [streakData, setStreakData] = useState([]);
  const [dailyLessons, setDailyLessons] = useState(0);



  const [popupOpen, setPopupOpen] = useState(false);
  const [selectedDay, setSelectedDay] = useState(null);
  const [selectedCompleted, setSelectedCompleted] = useState(false);

  const handleDayClickstrike = (day, completed) => {
    setSelectedDay(day);
    setSelectedCompleted(completed);
    setPopupOpen(true);
  };





const [userStats, setUserStats] = useState({
  xp: 0,
  coins: 0
});





const leagues = [
  { name: 'Liga Bronz', minXP: 0, maxXP: 99, icon: '🥉', className: 'bronze' },
  { name: 'Liga Argint', minXP: 100, maxXP: 299, icon: '🥈', className: 'silver' },
  { name: 'Liga Aur', minXP: 300, maxXP: 599, icon: '🥇', className: 'gold' },
  { name: 'Liga Diamond', minXP: 600, maxXP: Infinity, icon: '💎', className: 'diamond' },
];


const userXP = userStats.xp;


const userLeague =
  leagues.find(l => userXP >= l.minXP && userXP <= l.maxXP) || leagues[0];

const nextLeague =
  leagues[leagues.indexOf(userLeague) + 1];

const xpToNextLeague = nextLeague
  ? nextLeague.minXP - userXP
  : 0;

const nextLeagueName = nextLeague?.name ?? 'liga maximă';






const getLocalISODate = (date = new Date()) => {
  return [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, '0'),
    String(date.getDate()).padStart(2, '0'),
  ].join('-');
};






const WEEK_DAYS = ['D','L','M','M','J','V','S'];


// Corect: ultimele 7 zile (azi, ieri, ...)

// Construim ultimele 7 zile (de la cea mai veche la cea mai nouă)
const all7Days = [...Array(7)].map((_, i) => {
  const d = new Date();
  d.setDate(d.getDate() - (6 - i));

  const iso = getLocalISODate(d);

  const match = streakData.find(s => {
    const sDay =
      typeof s.day === 'string'
        ? s.day.split('T')[0]
        : s.day;
    return sDay === iso;
  });

  return {
    date: iso,
    label: WEEK_DAYS[d.getDay()],
    completed: match?.completed ?? false,
    today: iso === getLocalISODate(),
  };
});


// Păstrăm ordinea cronologică (ultimele 7 zile, de la stânga la dreapta)
const last7Days = all7Days;


// Calculează streak-ul real (zile consecutive completate, de la azi spre trecut)
// (mutat mai jos, să nu fie dublat)

// Marchează doar zilele din streak (vizual)

// Calculează streak-ul real (zile consecutive completate, de la azi spre trecut)
const currentStreak = [...last7Days]
  .reverse()
  .reduce((count, day) => {
    if (day.completed) return count + 1;
    return count;
  }, 0);


const last7DaysWithStreak = (() => {
  let streakActive = true;

  return [...last7Days]
    .reverse()
    .map(day => {
      if (streakActive && day.completed) {
        return { ...day, inStreak: true };
      }
      streakActive = false;
      return { ...day, inStreak: false };
    })
    .reverse();
})();


const streakDaysForDisplay = [
  ...last7DaysWithStreak.filter(day => day.inStreak),
  ...last7DaysWithStreak.filter(day => !day.inStreak),
];



const todayISO = getLocalISODate();





useEffect(() => {
  const fetchAll = async () => {
    try {
      // 👤 user
      const userRes = await fetch(`${apiUrl}/user`, {
        credentials: 'include',
      });
      const user = await userRes.json();
      setUserData(user);

      // 📊 stats
      const statsRes = await fetch(
        `${apiUrl}/user/${user.user_id}/stats`,
        { credentials: 'include' }
      );
      const stats = await statsRes.json();
      setUserStats({
        xp: stats.xp ?? 0,
        coins: stats.coins ?? 0,
      });

      // 🔥 DAILY LESSONS + STREAK (REAL)
      const dailyRes = await fetch(`${apiUrl}/daily-lessons`, {
        credentials: 'include',
      });

      if (!dailyRes.ok) {
        console.error('❌ Daily lessons fetch failed:', dailyRes.status);
        return;
      }

      const daily = await dailyRes.json();
      console.log('📚 Daily lessons received:', daily);

      // 🟢 lecții azi (din DB)
      const lessonsToday = daily.today?.lessons_completed ?? 0;
      setDailyLessons(lessonsToday);

      // 🟢 construim streakData DOAR din DB (cu toate datele pentru grafic)
      const history = (daily.history ?? []).map(d => ({
        day: d.day,
        completed: d.completed,
        lessons_completed: d.lessons_completed ?? 0,
        applications_completed: d.applications_completed ?? 0,
        tests_completed: d.tests_completed ?? 0,
      }));

      const today = daily.today
        ? [{
            day: daily.today.day,
            completed: daily.today.completed,
            lessons_completed: daily.today.lessons_completed ?? 0,
            applications_completed: daily.today.applications_completed ?? 0,
            tests_completed: daily.today.tests_completed ?? 0,
          }]
        : [];

      setStreakData([...history, ...today]);
      
      console.log('📊 StreakData loaded:', [...history, ...today]);

    } catch (err) {
      console.error('UserPage error:', err);
    } finally {
      setLoading(false);
    }
  };

  fetchAll();
}, []);


  console.log('🔄 Render - dailyLessons value:', dailyLessons);
  console.log('🔄 Render - streakData:', streakData);

  if (loading) return (
    <div className="welcome-screen-lesson">
      <div className="loading-dots">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );



  return (
    <div className="user-background-info">
      {/* Header profil */}
      <div className="user-profile-header">
  <div className="user-profile-info">

    <div className='user-orientation-picture'>
      <div className="user-avatar-container-large">
      {userData?.profile_picture ? (
        <img src={userData.profile_picture} alt="user" className="user-avatar-large" />
      ) : (
        <FontAwesomeIcon icon={faUserRegular} className="default-profile-icon-large" />
      )}
    </div>
    <div className="user-greeting">
    <h2>Salut, {userData?.username || 'Vizitator'} 👋</h2>

    <div className="user-plan-badge">
      {userData?.account_type === 'premium' ? (
        <span className="plan-badge premium" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
          <FontAwesomeIcon icon={faCrown} style={{ marginRight: 6 }} />
          PREMIUM
          <FontAwesomeIcon icon={faCrown} style={{ marginLeft: 6 }} />
        </span>
      ) : (
        <span className="plan-badge standard">Standard</span>
      )}
    </div>


    </div>
    
    </div>

    <div className='line-between-user-stats'></div>

      {/* Indicatori rapizi */}
    <div className="user-quick-stats">

      <div className="quick-stats-row">


          <div className="xp-coin-cards">
            <div className="xp-coin-card">
              <img src={coin} alt="Monede" className="xp-coin-icon" />
              <div className="xp-coin-value">{userStats.coins}</div>
              <div className="xp-coin-label">Monede</div>
            </div>
            <div className="xp-coin-card">
              <img src={light} alt="XP" className="xp-coin-icon" />
              <div className="xp-coin-value">{userStats.xp}</div>
              <div className="xp-coin-label">XP</div>
            </div>
          </div>


      

      </div>

      {/* Liga utilizatorului */}
      <div className="user-league">
        <span className={`league-badge ${userLeague.className}`}>
          {userLeague.icon} {userLeague.name}
        </span>

        <p className="league-progress">
          Mai ai <strong>{xpToNextLeague} XP</strong> până la {nextLeagueName}
        </p>
      </div>

    </div>

  </div>
</div>
{userData?.account_type === 'premium' ? (
  <div className="user-pro-banner premium-active" style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
    <span className="banner-logo" style={{ fontWeight: 700, fontSize: 20, marginRight: 10 }}>ContaLearn</span>
    <span className="banner-badge premium">PREMIUM</span>
  </div>
) : (
  <div className="user-pro-banner minimal-banner">
    <div className="banner-left">
      <span className="banner-logo">ContaLearn</span>
      <span className={`banner-badge ${userData?.account_type === 'premium' ? 'premium' : 'standard'}`}>
        {userData?.account_type === 'premium' ? 'PREMIUM' : 'STANDARD'}
      </span>
    </div>

    <div className="banner-center-status">
      Obtine acces complet!
    </div>

    <div className="banner-right">
      <Link to="/viewplans" className="banner-cta">
        Incearca Premium
      </Link>
    </div>
  </div>
)}





      {/* Dashboard */}
      <div className="general-dashboard">
        <div className="dashboard-left">
          {/* 🔥 Streak Card */}
          <div className="streak-cardup">
           

  {/* HEADER */}



  {/* DAYS */}


<StreakDays
  streakDaysForDisplay={streakDaysForDisplay}
  handleDayClickstrike={handleDayClickstrike}
  dailyLessons={dailyLessons}
  currentStreak={currentStreak}
/> 






           <div className='line-between-strikes'></div>
           <div className="streak-card-second-up">
  <div className="activity-chart-pro">
    <div className="chart-header-pro">
      <h3 className="chart-title-pro">Activitate saptamanala</h3>
      <span className="chart-subtitle-pro">Lectii completate zilnic</span>
    </div>
    
    <div className="chart-container-pro">
      <div className="chart-grid-pro">
        {[0, 2, 4, 6, 8, 10].map(val => (
          <div key={val} className="grid-line-pro">
            <span className="grid-label-pro">{val}</span>
          </div>
        ))}
      </div>
      
      <div className="chart-bars-pro">
        {[...Array(7)].map((_, i) => {
          const d = new Date();
          d.setDate(d.getDate() - (6 - i));
        const iso = getLocalISODate(d);

          
          // Normalizăm data din streakData la format YYYY-MM-DD
          const match = streakData.find(s => {
            const sDay = typeof s.day === 'string' ? s.day.split('T')[0] : s.day;
            return sDay === iso;
          });
          
          const lessons = match?.lessons_completed ?? 0;
          const maxLessons = 10;
          const heightPercent = lessons > 0 ? Math.max(Math.min((lessons / maxLessons) * 100, 100), 15) : 0;
          
          const isToday = iso === getLocalISODate();

          
          return (
            <div key={i} className="chart-bar-col-pro">
              <div className="bar-wrapper-pro">
                {lessons > 0 ? (
                  <div 
                    className={`bar-pro ${isToday ? 'bar-today-pro' : ''}`}
                    style={{ height: `${heightPercent}%` }}
                  >
                    <div className="bar-inner-pro">
                      <span className="bar-value-pro">{lessons}</span>
                    </div>
                    <div className="bar-tooltip-pro">
                      {lessons} {lessons === 1 ? 'lecție' : 'lecții'}
                      <br />
                      <small>{isToday ? 'Astăzi' : d.toLocaleDateString('ro-RO', { month: 'short', day: 'numeric' })}</small>
                    </div>
                  </div>
                ) : (
                  <div className="bar-empty-pro">
                    <div className="bar-tooltip-pro">
                      Nicio lecție
                      <br />
                      <small>{isToday ? 'Astăzi' : d.toLocaleDateString('ro-RO', { month: 'short', day: 'numeric' })}</small>
                    </div>
                  </div>
                )}
              </div>
              <span className={`bar-label-pro ${isToday ? 'label-today-pro' : ''}`}>
                {WEEK_DAYS[d.getDay()]}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  </div>
</div>

          </div>

        <div className='part-of-pu'>

           {/* 🏅 Ranking */}
          
   {/* Diplome */}


   <div className='daily-key-card'>
             <CoursesProgress />
          </div>
          
     <div className="provocarea-zilei medals-card">
        <div className="medals-card-header">
          <div className="medals-icon-wrapper">
            <FontAwesomeIcon icon={faMedal} className="medals-icon-fa" />
          </div>
          <h4 className="medals-title">Medalii</h4>
        </div>

        <div className="medals-stats">
          <div className="medals-stat-item">
            <span className="medals-stat-number">0</span>
            <span className="medals-stat-label">Câștigate</span>
          </div>
          <div className="medals-stat-divider"></div>
          <div className="medals-stat-item">
            <span className="medals-stat-number">12</span>
            <span className="medals-stat-label">Disponibile</span>
          </div>
        </div>

        <div className="medals-preview">
          <div className="medal-preview-item locked">
            <span className="medal-emoji">🥉</span>
            <span className="medal-name">Începător</span>
          </div>
          <div className="medal-preview-item locked">
            <span className="medal-emoji">🥈</span>
            <span className="medal-name">Expert</span>
          </div>
          <div className="medal-preview-item locked">
            <span className="medal-emoji">🥇</span>
            <span className="medal-name">Maestru</span>
          </div>
        </div>

        <p className="medals-description">
          Completează lecții și provocări pentru a debloca medalii speciale
        </p>

        <Link to="/medals" className="ranking-button medals-btn">
          Vezi toate medaliile
        </Link>
      </div>





     


          



        </div>


         <div className='part-of-pu'>

           {/* 🏅 Ranking */}
          
   {/* Diplome */}
        <div className="diploma-card">
          <div className="diploma-header">
            
              <h4 className="diploma-title-userpage">Certificate</h4>
                <img src={certificate} alt="Certificate" className="diploma-icon" />
            </div>

            <div className="diploma-content">
              <p className="diploma-message">Inca nu ai obtinut certificari</p>
              <p className="diploma-subtitle">Completeaza cursurile pentru a primi certificate oficiale</p>
            </div>

            <Link to="/diplome" className="diploma-button">
              Mergi catre certificate
            </Link>
        </div>



     
{/* 

          <div className='daily-challenge-card'>
            <div className="daily-challenge-header">
              <div className="challenge-icon-wrapper">
                <span className="challenge-icon">🎯</span>
              </div>
              <h4 className="challenge-title">Obiectivul de Azi</h4>
            </div>

            <div className="challenge-content">
              <div className="challenge-progress-info">
                <div className="challenge-stat">
                  <span className="stat-number">{dailyLessons}</span>
                  <span className="stat-label">Lecții completate</span>
                </div>
                <div className="challenge-stat">
                  <span className="stat-number">{currentStreak}</span>
                  <span className="stat-label">Zile consecutive</span>
                </div>
              </div>

              <div className="challenge-task">
                <div className="task-icon">✓</div>
                <div className="task-info">
                  <p className="task-title">Completează 3 lecții</p>
                  <div className="task-progress-bar">
                    <div 
                      className="task-progress-fill" 
                      style={{ width: `${Math.min((dailyLessons / 3) * 100, 100)}%` }}
                    ></div>
                  </div>
                  <p className="task-subtitle">
                    {dailyLessons >= 3 
                      ? '🎉 Obiectiv atins!' 
                      : `${3 - dailyLessons} lecții rămase`
                    }
                  </p>
                </div>
              </div>
            </div>

            <Link to="/courses" className="challenge-button">
              {dailyLessons >= 3 ? 'Continuă să înveți' : 'Începe acum'}
            </Link>
          </div>
          */}

          

        </div>

         
         
        </div>

        {/* Lecții */}
       
      </div>

      {/* 🔳 Popup */}
      {popupOpen && (
        <StreakPopup
          day={selectedDay}
          completed={selectedCompleted}
          onClose={() => setPopupOpen(false)}
        />
      )}
    </div>
  );
};

export default UserPage;
